// Дублирует backend/app/auth/constants.py - общего механизма BE/FE нет, синхронизируется
// вручную. Используется только для мгновенной подсказки в EditProfileDialog.vue,
// источник истины - бэкенд (400 при совпадении).
export const USERNAME_PATTERN = /^[a-z0-9_]{3,30}$/;

export const RESERVED_USERNAMES = new Set([
    "map",
    "live",
    "explore",
    "profile",
    "admin",
    "auth",
    "api",
    "login",
    "register",
    "settings",
    "www",
    "static",
    "assets",
    "health",
    "null",
    "undefined",
    "favicon",
    "user",
]);
